import { useSelector } from "react-redux";

function readStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("userData")) || null;
  } catch {
    return null;
  }
}

export default function LoadScreen() {
  const users = useSelector((state) => state.UserProfile.profile);
  const user = readStoredUser();
  return (
    <div className="loading-screens">
      <div className="loading-logos">
        <img
          src={users?.logo || user?.logo || "/image/logo.svg"}
          alt="logo"
        />
      </div>
      <p className="loading-texts">Please wait, we are fetching your data...</p>
    </div>
  );
}




